export const DEPOSIT_ROUTING = [
    {
        path: '/deposit',
        name: 'deposit',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Ký gửi', pathName: 'deposit', icon: 'fa fa-envelope' },
            ]
        },
        component: () => import('./Deposit.vue'),
        redirect: { name: 'deposit-index' },
        children: [
            { 
                path: '/deposit.html',
                name: 'deposit-index',
                component: () => import('./components/main-deposit/MainDeposit.vue')
            },
            {
                path: '/deposit/deposit-new.html',
                name: 'deposit-new',
                meta: {
                    breadcrumb: [
                        { name: 'Tạo mới ký gửi', pathName: 'deposit-new', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('./components/add-new-deposit/AddNewDeposit.vue'),
            },
            {
                path: '/deposit/:id',
                name: 'deposit-detail',
                meta: {
                    breadcrumb: [
                        { name: 'Chi tiết ký gửi', pathName: 'deposit-detail', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('./components/detail-deposit/DetailDeposit.vue'),
            }
        ]
    }
];